"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTree = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_ui_1 = require("@yanzi/react-ui");
const react_1 = require("react");
const Root_1 = require("./Root");
const SearchResults_1 = require("./SearchResults");
function AssetTree(_a) {
    var { selection, onSelect } = _a, props = __rest(_a, ["selection", "onSelect"]);
    const [searchInput, setSearchInput] = react_1.useState('');
    const isSearching = !!searchInput.length;
    return (jsx_runtime_1.jsxs(react_ui_1.Flex, Object.assign({ flexDirection: "column", height: "100%" }, props, { children: [jsx_runtime_1.jsxs(react_ui_1.FormGroup, Object.assign({ position: "relative", id: "search" }, { children: [jsx_runtime_1.jsx(react_ui_1.TextInput, { placeholder: "Search assets...", borderRadius: 3, value: searchInput, onChange: e => setSearchInput(e.target.value) }, void 0),
                    isSearching && (jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ position: "absolute", right: 0, top: 0, bottom: 0, backgroundColor: "transparent", mr: 1, display: "flex", px: 2, py: 0, alignItems: "center", justifyContent: "center", onClick: () => setSearchInput('') }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes }, void 0) }), void 0))] }), void 0),
            jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ flex: 1, overflowY: "auto", mx: -3, px: 3, py: 1, pb: 4, mb: -4, mt: 2 }, { children: isSearching ? (jsx_runtime_1.jsx(SearchResults_1.SearchResults, { term: searchInput, onSelect: onSelect, selection: selection }, void 0)) : (jsx_runtime_1.jsx(Root_1.Root, { selection: selection, onSelect: onSelect }, void 0)) }), void 0)] }), void 0));
}
exports.AssetTree = AssetTree;
//# sourceMappingURL=index.js.map